import { ORDER } from 'config/api-routes';
import { TFunction } from 'i18next';
import { OrderType, PartialOrderType } from 'types/order.types';
import { GET, PATCH, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class OrderService {
  async getOrder(orderId: number, opts = {}): Promise<OrderType> {
    const res = await GET(ORDER.ONE.GET(orderId), opts);

    return formatResponse(res);
  }

  async getOrders(queryParams = {}, opts = {}): Promise<{ list: OrderType[]; total: number }> {
    const res = await GET(ORDER.LIST.GET(queryParams), opts);

    return formatResponse(res);
  }

  async updateOrder(orderId: number, orderData: PartialOrderType, opts = {}): Promise<OrderType> {
    const response = await PATCH(ORDER.UPDATE.PATCH(orderId), orderData, opts);

    return formatResponse(response);
  }

  async updateOrderBarcode(orderId: number, orderData: PartialOrderType, opts = {}): Promise<OrderType> {
    const response = await PATCH(ORDER.UPDATE.BARCODE.PATCH(orderId), orderData, opts);

    return formatResponse(response);
  }

  async requestOrderDoorCode(orderId: number, data: { fromTerminalId: string; phone: string }, opts = {}): Promise<OrderType> {
    const response = await POST(ORDER.UPDATE.DOOR_CODE.POST(orderId), data, opts);

    return formatResponse(response);
  }

  async order(data, opts = {}) {
    const response = await POST(ORDER.SUBMIT.POST(), data, opts);

    return formatResponse(response);
  }

  getShippingProviderTrackingUrl = (shippingMethod: string, barcode: string, t: TFunction): string => {
    if (!barcode) {
      return;
    }

    const trackingUrl = t(`links.shipping.${shippingMethod}.tracking`);

    if (!trackingUrl) {
      return;
    }

    return trackingUrl + barcode;
  };
}
